const Navigation = {
  _body: document.body,
  _navPanel: document.querySelector('nav.navigation'),
  _navButton: document.querySelector('.header__button'),
  _header: document.querySelector('[data-header-scroll]'),

  init() {
    this.initEvents()
  },

  initEvents() {
    let scrollPos = window.scrollY;

    this._navButton.addEventListener('click', () => {
      this._body.classList.toggle('menu-is-open')
    })

    window.addEventListener('scroll', () => {
      scrollPos = window.scrollY;
      if (scrollPos >= 100) { this.addHeaderScrollClass() } else { this.removeHeaderScrollClass() }
    })
  },

  addHeaderScrollClass() {
    this._header.classList.add('has-fill')
  },

  removeHeaderScrollClass() {
    this._header.classList.remove('has-fill')
  },

}

export default Navigation
